import { SET_NEW_NOTIFICATION, SET_READ_NOTIFICATION } from './actionTypes';

export const newNotification = () => ({
  type: SET_NEW_NOTIFICATION
});

export const readNotification = () => ({
  type: SET_READ_NOTIFICATION
});
